<template>
  <div class="doctorpc-apply-attach">
    <docpc-steps :current="stepActive"></docpc-steps>
    <div class="docpc-panel">
      <div class="form-box">
        <div class="docpc-form-title">
          认证材料上传
          <div class="tips">选择材料类型（两类材料二选一）</div>
        </div>
        <van-tabs class="docpc-tabs-card" type="card">
          <van-tab title="执业医师资格">
            <div class="attach-list">
              <div class="list-item" v-for="(dcitem, dcindex) in attach_list1" :key="dcindex">
                <upload-attach :item="dcitem" @confirm="attachConfirm"></upload-attach>
              </div>
            </div>
          </van-tab>
          <van-tab title="身份证+卫健委截图">
            <div class="attach-list">
              <div class="list-item" v-for="(idcitem, idcindex) in attach_list2" :key="idcindex">
                <upload-attach :item="idcitem" @confirm="attachConfirm"></upload-attach>
              </div>
            </div>
          </van-tab>
        </van-tabs>
        <div class="docpc-form-btn">
          <div class="btn-item">
            <van-button block size="small" :disabled="btnDisabled" @click="goBack()">返回</van-button>
          </div>
          <div class="btn-item">
            <van-button :color="themeColor" block size="small" :disabled="btnDisabled" @click="submit()">确认</van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import temp_idc1 from "@/assets/docpc/temp_idc1.jpg" // 身份证国徽页示例图
import temp_idc2 from "@/assets/docpc/temp_idc2.jpg" // 身份证人像页示例图
import temp_dc1 from "@/assets/docpc/temp_dc1.jpg" // 执业医生资格证人像页
import temp_dc2 from "@/assets/docpc/temp_dc2.jpg" // 执业医生资格证身份信息页
import docpcSteps from "@/doctor_pc/components/steps/steps.vue"
import uploadAttach from "@/doctor_pc/components/upload/uploadAttach.vue"
import {
  ImagePreview,
  Toast,
} from "vant";
import {
  doctorGetDetail
} from '@/api/doctorapi';
import {
  mapState,
  mapActions
} from "vuex";
Vue.use(ImagePreview)

export default {
  name: 'docpcApplyAttach',
  components: {
    docpcSteps,
    uploadAttach,
  },
  data() {
    return {
      themeColor: this.themeColor,
      stepActive: null,
      btnDisabled: false,
      infoattach: [],
      headattach: [],
      idcard_front: [], // 身份证人像页
      idcard_back: [], // 身份证国徽页
      caram: [],
      attach_list1: [
        {
          label: '执业医生资格证人像页',
          name: 'headattach',
          value: [],
          upload_filecount: 9,
          sample_image: temp_dc2
        },
        {
          label: '执业医生资格证身份信息页',
          name: 'infoattach',
          value: [],
          upload_filecount: 9,
          sample_image: temp_dc1
        }
      ],
      attach_list2: [
        {
          label: '身份证人像面',
          name: 'idcard_front',
          value: [],
          upload_filecount: 9,
          sample_image: temp_idc2
        },
        {
          label: '身份证国徽面',
          name: 'idcard_back',
          value: [],
          upload_filecount: 9,
          sample_image: temp_idc1
        },
        {
          label: '卫建委网站医生注册信息查询截图',
          name: 'caram',
          value: [],
          upload_filecount: 9,
        }
      ]
    }
  },
  computed: {
    ...mapState(['docpc']),
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions(['SET_DOCPC_FORM','CLEAR_DOCPC_FORM']),
    goBack() {
      this.$router.back()
    },
    async getData() {
      await doctorGetDetail({params:{id: this.docpc.docpcInfo.doctor.id}}).then(res => {
        console.log('doctorGetDetail', res.data)
        // if (!res.data.doctor.status && this.$route.query.isNew == 1) {
        //   this.isnew = this.$route.query.isNew
        // }
        if (this.docpc.docpcForm && this.docpc.docpcForm.hasOwnProperty('attaches') && Object.keys(this.docpc.docpcForm.attaches).length>0) {
          let arr = this.docpc.docpcForm.attaches
          for (let i in this.attach_list1) {
            let elei = this.attach_list1[i]
            if (arr.hasOwnProperty(elei.name)) {
              elei.value = arr[elei.name]
            }
          }
          for (let j in this.attach_list2) {
            let elej = this.attach_list2[j]
            if (arr.hasOwnProperty(elej.name)) {
              elej.value = arr[elej.name]
            }
          }
        } else if (res.data.attaches) {
          // if (this.isnew != 1) {
            for(let i in res.data.attaches) {
              let ele = res.data.attaches[i]
              let value = []
              if (i == '执业医生资格证人像页') {
                value = this.attach_list1[0].value
              } else if (i == '执业医生资格证身份信息页') {
                value = this.attach_list1[1].value
              } else if (i == '身份证人像面') {
                value = this.attach_list2[0].value
              } else if (i == '身份证国徽面') {
                value = this.attach_list2[1].value
              } else if (i == '卫健委网站医生注册信息查询截图') {
                value = this.attach_list2[2].value
              }
              for (let j in ele) {
                value.push({
                  id: ele[j].id,
                  src: ele[j].filepath
                })
              }
            }
          // }
          console.log('ddddd',this.attach_list1, this.attach_list2)
        }
        this.$forceUpdate();
      }).catch(err => {
        Toast(err.response.data.message)
      })
    },
    attachConfirm(e) {
      console.log('attachConfirm', e, this.attach_list1, this.attach_list2)
      let req = this.docpc.docpcForm
      console.log('attachConfirm 22', req)
      req.attaches[e.name] = e.value
      this.SET_DOCPC_FORM(req)
    },
    submit() {
      console.log('list', this.attach_list1, this.attach_list2)
      let b1 = Boolean(this.attach_list1[0].value.length>0 && this.attach_list1[1].value.length>0)
      let b2 = Boolean(this.attach_list2[0].value.length>0 && this.attach_list2[1].value.length>0 && this.attach_list2[2].value.length>0)
      if (b1 || b2) {
        this.goBack()
      } else {
        Toast('请上传认证材料（两类材料二选一）')
      }
    },
  }
}
</script>

<style lang='less'>
.doctorpc-apply-attach {
  .attach-list {
    .list-item {
      padding: 20px 16px; border-bottom: #eee solid 1px;
      .item-title {
        font-size: 16px; margin-bottom: 20px;
      }
      .item-upload {
        display: flex; align-items: center;
        .bd {
          flex: 1; min-width: 0; margin-right: 50px;
        }
        .van-uploader__preview-image {
          border-radius: 0;
        }
        .van-uploader__upload {
          box-shadow: 0 0 0 1px #eee; border-radius: 0;
        }
        .van-image {
          background: #f3f3f3; box-shadow: 0 0 0 1px #eee;
        }
      }
      &:last-child {
        border-bottom-width: 0;
      }
    }
  }
}
</style>